import { render, staticRenderFns } from "./common-employee-id.vue?vue&type=template&id=04b7d6c2"
import script from "./common-employee-id.vue?vue&type=script&lang=js"
export * from "./common-employee-id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports